// src/modules/Caregaps2/dialogs/OutreachDialog.jsx
import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem,
} from "@mui/material";

const RESULT_OPTIONS = [
  "Reached – patient agreed to schedule",
  "Reached – patient declined service",
  "Reached – patient already completed elsewhere",
  "Reached – patient not eligible / wrong outreach",
  "Reached – patient requested more information",
  "Left voicemail – generic message",
  "Left voicemail – callback requested",
  "No answer – phone ringing",
  "Disconnected / wrong number",
  "Reached family member – message left",
];

const NEXT_ACTION_OPTIONS = [
  "Schedule appointment",
  "Attempt outreach again in 3 days",
  "Attempt outreach again in 2 weeks",
  "Send SMS reminder",
  "Send patient portal message",
  "Send letter to home address",
  "Escalate to care coordinator",
  "Verify contact information with clinic",
  "Close gap – completed",
  "Close gap – patient refused",
];

export default function OutreachDialog({ open, onClose, onConfirm, item }) {
  const [channel, setChannel] = React.useState("phone");
  const [result, setResult] = React.useState("");
  const [nextAction, setNextAction] = React.useState("");

  React.useEffect(() => {
    if (!open) {
      setChannel("phone");
      setResult("");
      setNextAction("");
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm?.({ channel, result, nextAction, item });
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Log Outreach – {item?.careGapName}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {/* Channel */}
          <TextField
            select
            label="Channel"
            value={channel}
            onChange={(e) => setChannel(e.target.value)}
            fullWidth
          >
            <MenuItem value="phone">Phone</MenuItem>
            <MenuItem value="sms">SMS</MenuItem>
            <MenuItem value="portal">Patient Portal</MenuItem>
          </TextField>

          {/* Result */}
          <TextField
            select
            label="Result"
            value={result}
            onChange={(e) => setResult(e.target.value)}
            fullWidth
          >
            {RESULT_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          {/* Next action */}
          <TextField
            select
            label="Next action"
            value={nextAction}
            onChange={(e) => setNextAction(e.target.value)}
            fullWidth
          >
            {NEXT_ACTION_OPTIONS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Save</Button>
      </DialogActions>
    </Dialog>
  );
}
